<div *ngIf="stats" class="total-stats">
  <div class="description">
    This information is updated daily.
  </div>

  <div class="stat">
    <div>
      <div class="title">Pathway count</div>
      <div class="value">{{stats.models}}</div>
    </div>
    <div class="desc">
      <div>Curated <i>S. pombe</i> pathways. (<a routerLink="/gocam/model-list">Full list</a>)</div>
    </div>
  </div>

  <div class="stat">
    <div>
      <div class="title">Total graph nodes</div>
      <div class="value">{{stats.nodes}}</div>
    </div>
    <div class="desc">
The total count of nodes across all individual GO-CAM model graphs.
The graph nodes are:
<ul>
  <li>
 genes that enable activities
  </li>
  <li>
 complexes that enable activities
  </li>
  <li>
 target genes or complexes
  </li>
  <li>
 chemicals
  </li>
</ul>
    </div>
  </div>

  <div class="stat">
    <div>
      <div class="title">Total graph edges</div>
      <div class="value">{{stats.edges}}</div>
    </div>
    <div class="desc">
The total count of edges across all individual GO-CAM model graphs. It
includes all edges between graph nodes.
    </div>
  </div>

  <div class="stat">
    <div>
      <div class="title">Connected activity nodes</div>
      <div class="value">{{stats.activities}}</div>
    </div>
    <div class="desc">
Count of connected activity nodes (the core building block
of a GO-CAM: a gene product or complex performing a specific molecular function)
across all individual GO-CAM model graphs (excludes connections to
chemicals and target genes that are not yet modelled as activities).
    </div>
  </div>

  <div class="stat">
    <div>
      <div class="title">Chemicals</div>
      <div class="value">{{stats.chemicals}}</div>
    </div>
    <div class="desc">
The total count of nodes across all individual GO-CAM model graphs
representing chemicals.
    </div>
  </div>

  <div class="stat">
    <div>
      <div class="title">Genes enabling activities</div>
      <div class="value">
<app-query-link [goToResults]="true" [predefinedQueryId]="'gocam_activity_gene_count'"></app-query-link>
      </div>
    </div>
    <div class="desc">
The count of genes that enable activities.  Genes that contribute to
complexes are included in the total.
    </div>
  </div>

  <div class="stat">
    <div>
      <div class="title">Target genes</div>
      <div class="value">{{stats.target_genes}}</div>
    </div>
    <div class="desc">
The total count of genes across all individual GO-CAM model graphs
which are represented as targets of an activity, but are not yet
modelled as enabling any activity.
    </div>
  </div>

  <div class="stat">
    <div>
      <div class="title">Total GO term occurrences</div>
      <div class="value">{{stats.total_go_term_occurrences}}</div>
    </div>
    <div class="desc">
The total count of all instances of GO terms used across all individual
GO-CAM model graphs. Individual uses of the same GO term are
counted separately.
    </div>
  </div>

  <div class="stat">
    <div>
      <div class="title">Count of GO term used</div>
      <div class="value">{{stats.distinct_go_terms}}</div>
    </div>
    <div class="desc">
The count of GO terms use across all GO-CAM pathways.  Individual uses
of the same GO term are not counted separately.
    </div>
  </div>

  <div class="stat">
    <div>
      <div class="title">Raw nodes</div>
      <div class="value">{{stats.raw_nodes}}</div>
    </div>
    <div class="desc">
The total count of all the nodes underlying the GO-CAM structure
across all individual GO-CAM models. It includes every node that is
included in the total graph nodes count, as well as every instance of
a GO term and every supporting evidence and provenance for all
annotations in the graph.
    </div>
  </div>

  <div class="stat">
    <div>
      <div class="title">Raw edges</div>
      <div class="value">{{stats.raw_edges}}</div>
    </div>
    <div class="desc">
The total count of edges between all the raw nodes across all
individual GO-CAM models.
    </div>
  </div>
</div>
